import 'ui-core/components/tabs/js/tabs.js';
import TabsA11y from '../../../utility/a11y/tabs';
import AdvancedSearch from '../../../widgets/advanced-search/js/advanced-search';

let vPort = 'screen-md',
    href = window.location.href;

UX.tab.vPort = vPort;

UX.tab.set.target = function ($content, target, temp) {
    target = target.replace('.', '\\.');

    if (!$content.find(target).length) {
        UX.tab.$target = $content.find(`[data-figure-id="${temp}"]`);
    } else {
        UX.tab.$target = $content.find(target);
    }

    if ($(target).parents('.accordion').length) {
        $(target)
            .parents('.accordion')
            .each(function () {
                let control = $(this).find('.accordion-tabbed__control');

                if (control.attr('aria-expanded') === 'false') control.click();
            });
    }
};

UX.tab.triggerExternal = $el => {
    let $tabsWrapper = $('.tabs__wrapper'),
        $tabNav = $tabsWrapper.find('.tab__nav'),
        tabsWrapperTop = $tabsWrapper[0].getBoundingClientRect().top,
        wrapperPaddingTop = tabsWrapperTop < 0 ? tabsWrapperTop * -1 - $tabNav.outerHeight() + 1 : 0,
        triggerExternal = () => {
            UX.tab.on.select.external($el);
        };

    $tabsWrapper.animate(
        {
            'padding-top': wrapperPaddingTop,
        },
        0,
        triggerExternal
    );
};

UX.tab.on.select.external = function (elem) {
    let target = elem.attr('href'); // get target id
    if (typeof target == 'undefined') {
        target = elem.children('a').attr('href');
    }

    // if it still is undefined output a console error
    if (typeof target != 'undefined') {
        target = target.split(' ')[0];
        UX.tab.$toggle = '#' + elem.data('tab');
        UX.tab.$li = $('.tab__nav [href="' + UX.tab.$toggle + '"]');

        UX.tab.$li.trigger('click');

        const animateScroll = () => {
            const temp = target.split('#')[1];
            UX.tab.$content = $(UX.tab.$toggle).parents('.tab__content');

            if (UX.tab.isMobile && UX.tab.isMobile[0]) {
                const wSlideContent = $('.w-slide__content');
                UX.tab.set.target(wSlideContent, target, temp);
                if (UX.tab.$target.length) {
                    UX.tab.animate.scroll(wSlideContent, UX.tab.$target);
                }
            } else {
                UX.tab.set.target(UX.tab.$content, target, temp);
                UX.tab.animate.scroll(UX.tab.$content, UX.tab.$target);
                UX.tab.$target.find('.back-to-article').addClass('js--show');
                UX.tab.$target.find(':focusable').eq(0).focus();
            }
        };

        if ($(UX.tab.$toggle).hasClass('empty')) {
            $(UX.tab.$toggle).on('content-loaded', function () {
                animateScroll();
            });
        } else {
            animateScroll();
        }
    } else {
        console.error('No valid href found');
    }
};

UX.tab.animate.scroll = ($content, $target) => {
    let slideHeadHeight = $target.closest('.w-slide__content').length ? $('.w-slide_head').height() : 0,
        animateDuration = UX?.loader?.isMobile ? 600 : 0;

    const setFocusOnTarget = () => {
        $target.attr('tabindex', '-1').focus();
    };

    if ($target.length) {
        $content.animate(
            {
                scrollTop: $target.position().top - slideHeadHeight,
            },
            animateDuration,
            setFocusOnTarget
        );
    }
};

UX.tab.additionalControl = function () {
    const tabContent = document.querySelector('.tabs__wrapper .tab__content');
    if (tabContent) {
        const tabs = UX.utils.convertToArray(document.querySelectorAll("a[data-toggle='tab']"));
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                tabContent.scrollTop = 0;
            });
        });
    }
    if ($('.navigation-tab.tab').length) {
        $(document).on('click', '.navigation-tab.tab .tab__nav a[data-toggle="tab"]', function () {
            let tabAttr = $(this).attr('href'),
                $tabButtonContent = $(tabAttr),
                $fixedElements = $('.fixed-element'),
                fixedHeader = 0;

            if ($fixedElements.length) {
                $fixedElements.each(function (index, fixed) {
                    fixedHeader += $(fixed).outerHeight();
                });
            }

            if ($('.stickybar__wrapper.fixed-element').length) {
                $(window).scrollTop($tabButtonContent.offset().top - fixedHeader);
            }
        });
    }

    $(document).on(vPort + '-on', function () {
        $(document).on('click', '.transplanted-clone .tab-cloned-list [data-toggle="tab"]', function (e) {
            let $tabButton = $(this),
                $parentList = $tabButton.closest('.dropBlock__holder'),
                dbTargetOf = $parentList.data('db-target-of'),
                $dbTargetFor = $parentList.siblings('[data-db-target-for="' + dbTargetOf + '"]'),
                $tabContentBox = $('.tab__pane[id="' + $tabButton.parent().attr('id') + '-pane"]').closest(
                    '.tab__content'
                ),
                fixedElement = 0;

            e.preventDefault();

            $parentList.removeClass('js--open');
            $dbTargetFor
                .removeClass('js--open')
                .attr('aria-expanded', 'false')
                .find('i')
                .removeClass('icon-close_thin');
            $('.lock-screen').removeClass('lock-screen');

            $('.pageHeader, .pages-nav--res').each(function (index, element) {
                if ($(element).css('position') === 'fixed') {
                    fixedElement += $(element).outerHeight();
                }
            });

            $(window).scrollTop($tabContentBox.offset().top - fixedElement);
        });
    });

    $(document).on('click focus', '[role="tab"]', function () {
        let $this = $(this),
            $targetedTab = $(`[aria-labelledby="${$this.attr('id')}"]`);

        $targetedTab
            .attr({
                'aria-hidden': false,
                tabindex: 0,
            })
            .siblings()
            .attr('aria-hidden', true)
            .removeAttr('tabindex');
    });
};
UX.tab.additionalAjaxSuccess = function () {
    if ($('.abstract-preview__zoom').length) {
        $('.abstract-preview__zoom').fancybox({
            helpers: {
                title: null,
            },
            afterShow: function () {
                setTimeout(function () {
                    $('body').find('.fancybox-close').focus();
                });
            },
        });
    }
    if ($('.citation.magicsuggest').length) {
        UX.quickSearch.doSuggest();
        setTimeout(function () {
            if (href.indexOf('publication') > -1) {
                $(document).find('input[name^="citation"][type="search"]').removeAttr('disabled');
            }
        });
    } else if ($('.search-term.magicsuggest').length) {
        setTimeout(function () {
            if (href.indexOf('field1') > -1) {
                $(document).find('input[name="text1"]').val(UX.utils.getUrlParameter('field1'));
                $(document).find('#advanced-search-btn').removeAttr('disabled');
            }
        });
    }

    $(document)
        .find('.ms-ctn input[type="text"]')
        .each(function (index, ms) {
            let $input = $(ms),
                $msCtn = $input.closest('.ms-ctn');

            if ($msCtn[0].hasAttribute('id')) {
                $input.attr('id', $msCtn.attr('id'));
                $msCtn.removeAttr('id');
            }
        });

    if ($('#citationSearchForm').length) {
        UX.quickSearch.init();
    }

    if (window.location.href.includes('utm')) {
        UX.utm.setElements();
        UX.utm.init();
    }
};

UX.tab.getContent = function ($elem) {
    let tabId = $elem.attr('data-tabId'),
        widgetId = $elem.attr('data-widgetId'),
        pbContext = encodeURIComponent($('meta[name=pbContext]').attr('content')),
        $tabBody = $elem.parents('.tab__pane'),
        isAdvancedSearch = '';

    if (
        $elem.closest('.advanced-search__top-section').length &&
        href.indexOf('/search') > -1 &&
        href.indexOf('publication') > -1
    ) {
        isAdvancedSearch = '&publication=' + UX.utils.getUrlParameter('publication');
    }

    $.ajax({
        url:
            '/pb/widgets/ux3/lazyTabs/loadTab?pbContext=' +
            pbContext +
            '&tabId=' +
            tabId +
            '&widgetId=' +
            widgetId +
            isAdvancedSearch,
        success: function (data) {
            $tabBody.attr('data-ajaxLoaded', 'true');
            $elem.replaceWith(data);
            if ($tabBody.find('.tab__pane.active').find('.tab-lazy').length) {
                UX.tab.getContent($tabBody.find('.tab__pane.active').find('.tab-lazy'));
            }
            $tabBody.find(UX.tab.$spinner).hide();
            UX.tab.additionalAjaxSuccess();
            const advancedSearchWidget = document.querySelector('.advanced-search-widget');
            if (advancedSearchWidget && !advancedSearchWidget?.querySelector('.autoComplete_wrapper')) {
                UX.advancedSearch = new AdvancedSearch(document.querySelector('.advanced-search')).initialize();
            }
        },
        error: function () {},
    });
};

const tablists = document.querySelectorAll('[role=tablist]');
tablists.forEach(tablist => {
    new TabsA11y(tablist).initialize();
});
